export const GA_EVENTS = {
  guest_mode_entered: 'guest_mode_entered',
  signup_started: 'signup_started',
  account_created: 'account_created',
  email_verification_sent: 'email_verification_sent',
  email_verified: 'email_verified',
  signin_completed: 'signin_completed',
  profile_picture_added: 'profile_picture_added',
  onboarding_completed: 'onboarding_completed',
  signin_failed: 'signin_failed',
  otp_verification_failed: 'otp_verification_failed',
  password_reset_completed: 'password_reset_completed',
  superapp_home_viewed: 'superapp_home_viewed',
  create_home_viewed: 'create_home_viewed',
  discover_opened: 'discover_opened',
  explore_opened: 'explore_opened',
  top_creators_opened: 'top_creators_opened',
  content_opened: 'content_opened',
  creator_profile_opened: 'creator_profile_opened',
  search_opened: 'search_opened',
  create_entry_opened: 'create_entry_opened',
  notifications_opened: 'notifications_opened',
  upgrade_prompt_opened: 'upgrade_prompt_opened', //pending
  // Tool Execution Events
  tool_opened: 'tool_opened',
  tool_help_viewed: 'tool_help_viewed',
  tool_input_added: 'tool_input_added',
  tool_input_removed: 'tool_input_removed',
  generation_started: 'generation_started',
  generation_completed: 'generation_completed',
  generation_failed: 'generation_failed',
  moderation_blocked: 'moderation_blocked',
  generation_retried: 'generation_retried',
  //output
  output_liked: 'output_liked',
  output_disliked: 'output_disliked',
  output_downloaded: 'output_downloaded',
  domore_started: 'domore_started',
  content_published: 'content_published',
  content_discarded: 'content_discarded',
  //content
  content_viewed: 'content_viewed',
  content_view_completed: 'content_view_completed',
  content_liked: 'content_liked',
  comment_posted: 'comment_posted',
  content_saved: 'content_saved',
  creator_profile_viewed: 'creator_profile_viewed',
  creator_followed: 'creator_followed',
  creator_unfollowed: 'creator_unfollowed',
  content_shared: 'content_shared',
  content_remixed: 'content_remixed',
  //subscription
  paywall_viewed: 'paywall_viewed', //pending
  subscription_page_viewed: 'subscription_page_viewed',
  subscription_plan_selected: 'subscription_plan_selected',
  promo_code_applied: 'promo_code_applied',
  subscription_purchased: 'subscription_purchased',
  payment_failed: 'payment_failed',
  topupcredits_purchased: 'topupcredits_purchased',
  subscription_cancelled: 'subscription_cancelled',
  //Wallet
  wallet_viewed: 'wallet_viewed',
  credits_purchase_initiated: 'credits_purchase_initiated',
  coins_converted: 'coins_converted',
  reward_redeemed: 'reward_redeemed',
  coins_earned: 'coins_earned',
  //notification
  notification_clicked: 'notification_clicked',
  //setting
  settings_opened: 'settings_opened',
  logout_confirmed: 'logout_confirmed',
  consent_screen_open:'consent_screen_open',
  consent_checkbox_selected:'consent_checkbox_selected',
  consent_accepted:'consent_accepted',
  consent_declined:'consent_declined',
  consent_revoked:'consent_revoked',
  consent_reconsent_required:'consent_reconsent_required',
  consent_reaccepted:'consent_reaccepted',
  consent_error:'consent_error'
}


export const CMS_EVENTS = {
  SIGNUP_STARTED: 'signup_started',
  CREATE_ACCOUNT_CLICKED: 'create_account_clicked',
  ACCOUNT_CREATED: 'account_created',
  SIGNUP_BUTTON_CLICKED: 'signup_button_clicked',
  ONBOARDING_COMPLETED: 'onboarding_completed',
  EXISTING_USER_SIGNIN_CLICKED: 'existing_user_signin_clicked',
  SIGNIN_BUTTON_CLICKED: 'signin_button_clicked',
  SIGNIN_COMPLETED: 'signin_completed',
  SIGNIN_FAILED: 'signin_failed',
  GOOGLE_SIGNIN_CLICKED: 'google_signin_clicked',
  APPLE_SIGNIN_CLICKED: 'apple_signin_clicked',
  RESET_PASSWORD_CLICKED: 'reset_password_clicked',

  //otp
  OTP_SENT_CLICKED: 'otp_sent_clicked',
  OTP_VERIFIED_CLICKED: 'otp_verified_clicked',
  OTP_SENT: 'otp_sent',
  VERIFY_OTP_CLICKED: 'verify_otp_clicked',
  OTP_VERIFIED: 'otp_verified',

  // Home Events
  HOME_VIEWED: 'home_viewed',
  CREATE_HOME_VIEWED: 'create_home_viewed',
  SUPERAPP_HOME_VIEWED: 'superapp_home_viewed',
  ENTER_CLICKED: 'enter_clicked',
  GUEST_MODE_ENTERED: 'guest_mode_entered',

  // App Events
  FIRST_OPEN: 'first_open',
  FIRST_VISIT: 'first_visit',
  APP_REMOVE: 'app_remove',
  APP_UPDATED: 'app_updated',
  CREATE_ENTRY_OPENED: 'create_entry_opened',

  // Coin Events
  REWARDS_EARNED: 'rewards_earned',
  REWARD_CONVERTED: 'reward_converted',

  // Session Events
  SESSION_START: 'session_start',
  SESSION_END: 'session_end',

  // Wallet Events
  WALLET_VIEWED: 'wallet_viewed',

  // Content Events
  CONTENT_PUBLISHED: 'content_published',
  CONTENT_SAVED: 'content_saved',
  CONTENT_SHARED: 'content_shared',
  CONTENT_REMIXED: 'content_remixed',
  CONTENT_OPENED: 'content_opened',

  // Tool Events
  TOOL_OPENED: 'tool_opened',

  // Subscription Events
  CREDITS_BUY_CLICKED: 'credits_buy_clicked',
  MONTHLY_PLAN_CLICKED: 'monthly_plan_clicked',
  YEARLY_PLAN_CLICKED: 'yearly_plan_clicked',
  TOPUP_PLAN_CLICKED: 'topup_plan_clicked',
  SELECT_PLAN_CLICKED: 'select_plan_clicked',
  APPLY_PROMO_CLICKED: 'apply_promo_clicked',
  CONTINUE_TO_PAY_CLICKED: 'continue_to_pay_clicked',
  PAYMENT_OPTION_CLICKED: 'payment_option_clicked',
  SUBSCRIPTION_PLAN_CLICKED: 'subscription_plan_clicked',
  SUBSCRIPTION_PURCHASED: 'subscription_purchased',
  SUBSCRIPTION_CANCELLED: 'subscription_cancelled',
  SUBSCRIPTION_PAGE_VIEWED: 'subscription_page_viewed',
  PAYMENT_FAILED: 'payment_failed',
  PROMO_CODE_ENTERED: 'promo_code_entered',
  CREDITS_PURCHASE_INITIATED: 'credits_purchase_initiated',
  APP_STORE_SUBSCRIPTION_RENEWED: 'app_store_subscription_renewed',

  // Notification Events
  NOTIFICATIONS_OPENED: 'notifications_opened',

  // Logout Events
  LOGOUT_CONFIRMED: 'logout_confirmed',

  // User Engagement Events
  USER_ENGAGEMENT: 'user_engagement',

  // Generation Events
  COLORIZE_BUTTON_CLICKED: 'colorize_button_clicked',
  GENERATE_BACKGROUND_CLICKED: 'generate_background_clicked',
  PUBLISH_NOW_CLICKED: 'publish_now_clicked',
  PUBLISH_RESULT_CLICKED: 'publish_result_clicked',
  GENERATION_STARTED: 'generation_started',
  GENERATION_COMPLETED: 'generation_completed',
  GENERATION_FAILED: 'generation_failed',
  SWAP_BUTTON_CLICKED: 'swap_button_clicked',


  // replica events
  SEARCH_ABANDONMENT: "search_abandonment",
  SUBSCRIPTION_FUNNEL_DROP_OFF: "subscription_funnel_drop_off",
  SUBSCRIPTION_STATUS_ACTIVE: "active",
  SUBSCRIPTION_STATUS_CANCELLED: "cancelled",
  SUBSCRIPTION_STATUS_EXPIRED: "churned",
  SIGNUP_ABANDONED: "signup_abandoned",
  OTP_FAILURE: "otp_failure",
  NO_CONTENT_INTERACTION: "no_content_interaction",
  ORGANIC_SEARCH: "Organic Search",
  SEARCH_EVENT:'search_event',
  HOME_PAGE_BOUNCE:"homepage_bounce",
  
  PAYMENT_TYPE_CARD:"card",
  PAYMENT_TYPE_UPI:'upi',
  PAYMENT_GATEWAY_STRIPE:"Stripe",
  PAYMENT_GATEWAY_RAZORPAY:"Razorpay",

  PARTNER_NAME: "ErosUniverse",
  PLATFORM: "Web",
  PLATFORM_ANDROID:"Android",
  PLATFORM_MWEB:"M-Web",
  PLAYER_ID:"Logix-Player",

  VIDEO_CONTENT_START: "content_start",
  VIDEO_CONTENT_END: "content_ended",
  VIDEO_CONTENT_PLAYED:"content_played",

  SUCCESS_PAYMENT:"payment_success",
  FAILED_PAYMENT:"payment_failed",

  CREDITS:"credits",
  COIN_TO_CREDIT:"coin_to_credit",

  COIN_EARN:"coined_earn",
  INPUT_TYPE_IMAGE:"image",
  INPUT_TYPE_VIDEO:"video",
  INPUT_TYPE_AUDIO:'audio',
  INPUT_TYPE_TEXT:"text",
  INPUT_SOURCE_PROMPT:"prompt",
  INPUT_SOURCE_UPLOAD:"upload",
  FAILED_MESSAGE:"failed",

  SUBSCRIPTION:"subscription",
  TOPUP:"topup",
  DEFAULT_COUNTRY:"India",
  USER_REGISTER: "user_register"
}
